











import { Vue, Component } from "vue-property-decorator";
import { getCurrentCompanyId } from "@/plugins/roles";
import api, { settingStorageApi } from "@/getinfo-api";
import CustomButton from "@/components/form/CustomButton.vue";
import Users, { UsersListParams } from "@/getinfo-api/users";

@Component({ components: { CustomButton } })
export default class UserGenerator extends Vue {
  domainMail!: { mail: string; count: number };
  password: string = "";
  isLoading: boolean = false;
  data() {
    return {
      domainMail: undefined
    };
  }

  get company() {
    return getCurrentCompanyId();
  }

  get generatedEmail() {
    return "u" + this.domainMail.count + "@" + this.domainMail.mail;
  }

  generate() {
    if (this.domainMail) {
      this.isLoading = true;
      this.domainMail.count++;

      Users({
        email: this.generatedEmail
      })
        .then(async res => {
          if (res.data.users?.length) {
            this.generate();
          } else {
            await settingStorageApi.Company.putCompanySettings(this.company, [
              {
                name: "domainMail",
                value: this.domainMail
              }
            ]).catch(() => {
              this.domainMail.count--;
            });
            this.generatePassword();
            this.$emit("generate", {
              mail: this.generatedEmail,
              password: this.password
            });
          }
        })
        .catch(() => {
          this.domainMail.count--;
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }

  generatePassword() {
    this.password = "";
    const charsNum = "0123456789";
    const lowerCase = "abcdefghijklmnopqrstuvwxyz";
    const upperCase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const symbols = "!@#$%^&*()";

    for (let i = 0; i <= 1; i++) {
      let randomNumber = Math.floor(Math.random() * charsNum.length);
      this.password += charsNum.substring(randomNumber, randomNumber + 1);
      let randomNumber2 = Math.floor(Math.random() * charsNum.length);
      this.password += lowerCase.substring(randomNumber2, randomNumber2 + 1);
      let randomNumber3 = Math.floor(Math.random() * charsNum.length);
      this.password += upperCase.substring(randomNumber3, randomNumber3 + 1);
      let randomNumber4 = Math.floor(Math.random() * charsNum.length);
      this.password += symbols.substring(randomNumber4, randomNumber4 + 1);
    }
  }

  created() {
    if (this.company) {
      settingStorageApi.Company.getCompanySettings(this.company, [
        "domainMail"
      ]).then(res => {
        //@ts-ignore
        this.domainMail = res.data[0].value;
      });
    }
  }
}
